import { render, staticRenderFns } from "./HomeSample.vue?vue&type=template&id=2625a54d&scoped=true&"
import script from "./HomeSample.vue?vue&type=script&lang=js&"
export * from "./HomeSample.vue?vue&type=script&lang=js&"
import style0 from "./HomeSample.vue?vue&type=style&index=0&id=2625a54d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625a54d",
  null
  
)

export default component.exports